import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from '../../../../../projects/common/src/app/services/cache.service';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { ILoopByMachineResponse } from '../interfaces/report-loop-by-machine';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { CommunicationService } from '../../../services/communication/communication.service';
import { Logger } from '../../../../../projects/common/src/app/classes/logger';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class ReportLoopByMachineService extends Logger {
  private baseUrl: string;
  constructor(
    private cacheService: CacheService,
    private http: HttpClient,
    private communicationService: CommunicationService,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * Function to get filtered result for loopByMachine report by selected filters
   *
   * @param selectedFilters Filters selected by user to get data
   */
  public getLoopByMachineFilterResult(selectedFilters: IOutputFilter, isTruck: boolean): Promise<ILoopByMachineResponse> {
    const params = this.setParams(selectedFilters);
    const endpoint = isTruck ? 'GetLoopsByTruckMachineReport' : 'GetLoopsByMachineReport';
    const url = `${this.baseUrl}/Report/${endpoint}`;
    return this.communicationService
      .get(url, params)
      .pipe(catchError((err) => this.handleError(err)))
      .toPromise();
  }

  /**
   * Get excel from GetChecklistReportDetailDocument endpoint
   */
  public GetLoopByMachineReportExcel(selectedFilters: IOutputFilter, isTruck: boolean): Observable<any> {
    const params = this.setParams(selectedFilters);
    const endpoint = isTruck ? 'GetLoopsByTruckMachineReportDocument' : 'GetLoopsByMachineReportDocument';
    const url = `${this.urlBuilder.apiUrl}/Report/${endpoint}`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: String(selectedFilters.shiftId),
      mineId: String(selectedFilters.zoneId),
      machineList: String(selectedFilters.machineId),
      companyId,
    };
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    this.error(err);
    return throwError(err);
  }
}
